// 検索結果ページの価格帯チップ（表示順）。未指定の側は null。
export const BUDGET_CHIPS = [
  { label: '〜999円', lowerBudget: null, higherBudget: 999 },
  { label: '1,000〜2,999円', lowerBudget: 1000, higherBudget: 2999 },
  { label: '3,000〜4,999円', lowerBudget: 3000, higherBudget: 4999 },
  { label: '5,000〜9,999円', lowerBudget: 5000, higherBudget: 9999 },
  { label: '10,000円〜', lowerBudget: 10000, higherBudget: null }
]
